import React from 'react';
import { cn } from '../../lib/utils';
import { Check, Clock, AlertCircle, TruckIcon, Calendar } from 'lucide-react';

interface SmartBadgeProps {
  variant:
    | 'arrives_before_service'
    | 'ready_to_install'
    | 'delayed'
    | 'in_transit'
    | 'upcoming'
    | 'today'
    | 'tomorrow'
    | 'completed';
  customText?: string;
  size?: 'small' | 'medium';
}

export function SmartBadge({ variant, customText, size = 'medium' }: SmartBadgeProps) {
  const config = {
    arrives_before_service: {
      icon: Check,
      text: 'Arrives Before Service',
      className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950/20 dark:text-green-400 dark:border-green-900',
    },
    ready_to_install: {
      icon: Check,
      text: 'Ready for Installation',
      className: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/20 dark:text-emerald-400 dark:border-emerald-900',
    },
    delayed: {
      icon: AlertCircle,
      text: 'Delivery Delayed',
      className: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950/20 dark:text-red-400 dark:border-red-900',
    },
    in_transit: {
      icon: TruckIcon,
      text: 'In Transit',
      className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/20 dark:text-blue-400 dark:border-blue-900',
    },
    upcoming: {
      icon: Calendar,
      text: 'Upcoming Service',
      className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/20 dark:text-blue-400 dark:border-blue-900',
    },
    today: {
      icon: Clock,
      text: 'Arrives Today',
      className: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/20 dark:text-orange-400 dark:border-orange-900',
    },
    tomorrow: {
      icon: Clock,
      text: 'Arrives Tomorrow',
      className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/20 dark:text-blue-400 dark:border-blue-900',
    },
    completed: {
      icon: Check,
      text: 'Completed',
      className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950/20 dark:text-green-400 dark:border-green-900',
    },
  };

  const { icon: Icon, text, className } = config[variant];
  const displayText = customText || text;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md font-medium border',
        size === 'small' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className
      )}
    >
      <Icon className={size === 'small' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      {displayText}
    </span>
  );
}
